import {
  TAGS_CHANGE_MINE,
  TAGS_CHANGE_ORG,
  TAGS_CHANGE_PROJECT,
  TAGS_CHANGE_USER
} from 'tools/SelectTags/graphql'
import { Label } from 'tools/Uniform'
import { strcmp } from 'utils/string'

import TagSelector from './TagSelector'

export function SelectTags({
  title = '',
  tagType,
  selectTag,
  children = undefined,
  target,
  labelClass = ' ',
  className = '',
  wrapClass = '',
  create = true,
  multi = undefined,
  normalizeOption,
  value,
  ...args
}) {
  return (
    <>
      {title && <Label className={labelClass}>{title}</Label>}
      <div className={wrapClass}>
        {children && <i>{children}</i>}
        <TagSelector
          className={className}
          normalizeOption={normalizeOption}
          tagType={tagType}
          multi={true}
          create={create}
          value={value || target?.tagsD?.[tagType] || []}
          setValue={(v) => selectTag(v, tagType, tagType, multi)}
          {...args}
        />
      </div>
    </>
  )
}

////////////////////////////////////////////////////////////////////////////////
function tagUpdate(tagChgMutation, args, onUpdate) {
  let tags = args.value
  const { tagType, ref, refId } = args
  if (!tags) {
    tags = []
  } else if (tags.constructor !== Array) {
    tags = [tags]
  }
  // let refetchQueries = []
  // if (ref === 'user') {
  //   refetchQueries = [ {query: LOAD_USER, variables: { id: 'self' }} ]
  // }
  tags = {
    tags: tags.map((tag) => {
      return { id: tag.id, label: tag.value || tag.label }
    }),
    tagType,
    ref,
    refId
  }
  tagChgMutation({
    variables: { tags },
    // refetchQueries,
    onCompleted(data) {
      onUpdate(args, data)
    }
  })
}

// mapId is the parent ID such as the user/project mapping
function normalizeTag({ tag, id: mapId, ...map }) {
  return Object.freeze({ ...map, ...tag, mapId })
}

export function normalizeTags2(data = []) {
  // console.log({ data })
  const [tags, types] = Object.freeze(
    data.reduce(
      ([tags, types], pTag) => {
        const tag = normalizeTag(pTag)
        tags[tag.id] = tag
        types[tag.type] = (types[tag.type] || []).concat(tag.id)
        return [tags, types]
      },
      [{}, {}]
    )
  )

  return {
    tags: Object.freeze(tags),
    types: Object.freeze(
      Object.keys(types).reduce((acc, type) => {
        // console.log({ acc, type })
        acc[type] = Object.freeze(
          types[type].toSorted((a, b) => strcmp(tags[a].label, tags[b].label))
        )
        return acc
      }, {})
    )
  }
}

export function normalizeTags(state, tags = []) {
  const tagsD = tags.reduce((acc, tag) => {
    const current = acc[tag.tag.type] || []
    acc[tag.tag.type] = current.concat(tag.tag)
    return acc
  }, {})
  return { ...state, tagsD, tags }
}

export {
  TAGS_CHANGE_USER,
  TAGS_CHANGE_PROJECT,
  TAGS_CHANGE_MINE,
  TAGS_CHANGE_ORG,
  tagUpdate
}
